<bn-web-ui-card
  [disableContent]="disableContent"
  [heading]="heading"
  [isFullHeight]="isFullHeight"
  [isHoverable]="isHoverable"
  [isLoading]="isLoading"
  [isRounded]="isRounded"
  [noBorder]="noBorder"
  [noPadding]="!hasPadding"
  [noShadow]="noShadow"
  [number]="number">
  <ng-content select="[description]" />
  <div class="bn-step-card__content">
    <ng-content />
  </div>
</bn-web-ui-card>
